import React from "react";
import { Col, Row, Badge } from "react-bootstrap";
import { object } from "prop-types";
import ExtendedBadge from "resources/images/dynamic_score_reports/extended-badge.png";
import { clptExpressSubTestIds } from "utils/helperConstants";
import { testInfoDescriptions } from "../constants";
import {
  renderResultsSummaryBox,
  getTestTypeIcon,
  getDynamicTestTypeBadgeClassName,
} from "../renderHelpers";
import { getSubTestInfoDescription } from "../helpers";

const TestInfoSection = ({ testInfo, selectedScoreRange }) => {
  if (!testInfo) {
    return null;
  }

  const reportInfo = testInfo.get("report");
  const testDetails = testInfo.get("test");

  const testId = testDetails.get("testId");
  const subTestId = reportInfo && reportInfo.getIn(["details", "subTestId"]);
  const testType = testDetails.get("testType");

  const summaryScores =
    testInfo.get("summary") || (reportInfo && reportInfo.get("summary"));
  const positions = reportInfo && reportInfo.getIn(["text", "positions"]);
  const translations = reportInfo && reportInfo.get("translations");

  const isExtended = reportInfo && reportInfo.get("extended");

  const testDescription =
    getSubTestInfoDescription(String(subTestId)) ||
    testInfoDescriptions[testId] ||
    (testDetails && testDetails.get("testDescription"));

  const ResultsSummaryBox = renderResultsSummaryBox(
    testId,
    summaryScores,
    reportInfo,
    reportInfo && reportInfo.get("details"),
    translations,
    positions,
    selectedScoreRange
  );

  const getTestName = () => {
    let testName = testDetails.get("testName");

    switch (testId) {
      case 46:
        // For WSP Long Form display
        if (reportInfo && subTestId !== 120) {
          testName += " - Long";
        }
        break;
      case 53:
      case 54:
      case 55:
        // Office 365
        testName = `Microsoft ${testName} Test`;
        break;
      case 57:
        if (clptExpressSubTestIds.includes(String(subTestId))) {
          testName += " Express";
        }
        testName += " - English";
        break;
      default:
        break;
    }

    return testName;
  };

  return (
    <Row className="mx-1 gray-bottom-border">
      <Col>
        <Row className="py-4">
          <Col lg={ResultsSummaryBox ? 7 : 12} className="pl-0">
            <Row className="pl-3">
              <Col lg={ResultsSummaryBox ? 2 : 1} className="pl-2 mr-2">
                {getTestTypeIcon(testType, testId)}
              </Col>
              <Col className="ml-1 mt-2">
                <div className="mb-2">
                  <Badge
                    bsPrefix={`badge-list-badge ${getDynamicTestTypeBadgeClassName(
                      testType
                    )}`}
                    className="text-center test-type"
                    style={{ padding: "4px 10px" }}
                  >
                    {testType.toUpperCase()} TEST
                  </Badge>
                  {isExtended && (
                    <img
                      src={ExtendedBadge}
                      alt="Extended time"
                      className="ml-2"
                    />
                  )}
                </div>
                <h2 className="score-detail-section-heading">
                  {getTestName()}
                </h2>
              </Col>
            </Row>
            <Row className="ml-2 mr-4 mt-3">
              <p>{testDescription}</p>
            </Row>
          </Col>
          <Col className="mr-2 ml-4 pr-0">{ResultsSummaryBox}</Col>
        </Row>
      </Col>
    </Row>
  );
};

TestInfoSection.propTypes = {
  testInfo: object,
  selectedScoreRange: object,
};

export default TestInfoSection;
